import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/cancel-invoices/rent-object-bookings/${formData.rentObjectBookingId}`, formData);
  },
  async findAll(formData) {
    return axios.get(`/cancel-invoices/rent-object-bookings/${formData.rentObjectBookingId}`);
  },
  async getAttachement(formData) {
    return axios.get(`/cancel-invoices/${formData.id}/pdf`, { responseType: 'arraybuffer' });
  },
  async delete({ id }) {
    return axios.delete(`/cancel-invoices/${id}`);
  },
};